export default __webpack_public_path__ + "static/media/heading-img.53aab390.png";